import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.authoring.review_batches');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { formatKstDate, formatKstDateTime } from "src/libs/portal/season/time";

@Component({
    selector: 'wiz-page-authoring-review_batches',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.authoring.review_batches/view.scss */
:host {
  display: block;
  height: 100%;
}

.batches-page {
  box-sizing: border-box;
  max-width: 1540px;
  min-height: 620px;
  margin: 24px auto 36px;
  padding: 0 22px 22px;
  border: 1px solid #dfe6e3;
  border-radius: 16px;
  color: #22312c;
  background: #fff;
}

.page-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  min-height: 70px;
  margin: 0 -22px 18px;
  padding: 0 22px;
  border-bottom: 1px solid #e7ecea;
}

.page-heading h1 {
  margin: 0 0 4px;
  color: #172f27;
  font-size: 20px;
  letter-spacing: -0.03em;
}

.page-heading p {
  margin: 0;
  color: #6f7e77;
  font-size: 12px;
}

.page-actions {
  display: flex;
  gap: 8px;
}

.adjudication-link, .refresh-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  box-sizing: border-box;
  border: 1px solid #cad9d2;
  border-radius: 8px;
  padding: 0 12px;
  background: #fff;
  color: #315e4c;
  font-size: 11px;
  font-weight: 700;
  text-decoration: none;
}

.batch-builder, .batch-history {
  overflow: hidden;
  border: 1px solid #dce5e1;
  border-radius: 12px;
  background: #fff;
}

.batch-builder {
  margin-bottom: 16px;
  padding: 18px;
}

.batch-builder > header, .batch-history > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.batch-builder h2, .batch-history h2 {
  margin: 0;
  color: #1d342b;
  font-size: 16px;
}

.batch-builder > header p {
  margin: 4px 0 0;
  color: #75837d;
  font-size: 11px;
}

.builder-form {
  display: grid;
  grid-template-columns: 1.15fr 1fr 0.7fr;
  gap: 10px;
  margin-top: 16px;
  padding: 12px;
  border-radius: 10px;
  background: #f7faf8;
}

.builder-form label {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.builder-form span {
  color: #607069;
  font-size: 11px;
  font-weight: 700;
}

.builder-form input, .builder-form select {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  border: 1px solid #d2ded8;
  border-radius: 8px;
  padding: 0 10px;
  background: #fff;
  color: #31433c;
  font-size: 12px;
}

.selection-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(280px, 0.75fr);
  gap: 12px;
  margin-top: 12px;
}

.candidate-selector, .reviewer-selector {
  min-width: 0;
  max-height: 470px;
  overflow: auto;
  border: 1px solid #e0e8e4;
  border-radius: 10px;
}

.candidate-selector > header, .reviewer-selector > header {
  position: sticky;
  z-index: 2;
  top: 0;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 9px;
  align-items: center;
  min-height: 58px;
  padding: 9px 12px;
  border-bottom: 1px solid #e7ece9;
  background: #fff;
}

.candidate-selector > header > div:first-child strong, .reviewer-selector > header > div:first-child strong {
  display: block;
  color: #28443a;
  font-size: 13px;
}

.candidate-selector > header > div:first-child small, .reviewer-selector > header > div:first-child small {
  display: block;
  margin-top: 2px;
  color: #77867f;
  font-size: 10px;
}

.selection-actions {
  display: flex;
  gap: 4px;
}

.selection-actions button, .candidate-selector form button {
  min-height: 30px;
  border: 1px solid #cce0d6;
  border-radius: 7px;
  padding: 0 8px;
  background: #edf7f2;
  color: #27694f;
  font-size: 10px;
  font-weight: 700;
}

.selection-actions .text-button {
  border-color: transparent;
  background: transparent;
  color: #708078;
}

.selection-actions button:disabled {
  opacity: 0.45;
}

.candidate-selector form {
  display: flex;
  grid-column: 1/-1;
  gap: 5px;
}

.candidate-selector form input {
  flex: 1;
  min-width: 0;
  height: 30px;
  box-sizing: border-box;
  border: 1px solid #d5dfda;
  border-radius: 7px;
  padding: 0 8px;
  font-size: 11px;
}

.candidate-card, .reviewer-card {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 9px;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 11px 12px;
  border-bottom: 1px solid #edf1ef;
  background: #fff;
  cursor: pointer;
}

.candidate-card:hover, .reviewer-card:hover {
  background: #f7fbf8;
}

.candidate-card.selected, .reviewer-card.selected {
  background: #eff9f4;
}

.candidate-card input, .reviewer-card input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: #1f805d;
}

.candidate-card span, .reviewer-card span {
  min-width: 0;
}

.candidate-card strong, .candidate-card small, .reviewer-card strong, .reviewer-card small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.candidate-card strong, .reviewer-card strong {
  color: #2a4037;
  font-size: 12px;
  font-weight: 700;
}

.candidate-card small, .reviewer-card small {
  margin-top: 3px;
  color: #83918a;
  font-size: 10px;
}

.reviewer-card em {
  padding: 4px 6px;
  border-radius: 5px;
  background: #eef2f7;
  color: #65738d;
  font-size: 10px;
  font-style: normal;
}

.selector-empty {
  padding: 48px 20px;
  color: #89958f;
  font-size: 11px;
  text-align: center;
}

.batch-builder > footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 12px;
  padding: 13px;
  border-radius: 10px;
  background: #f7faf8;
}

.batch-builder > footer strong {
  color: #285b47;
  font-size: 13px;
}

.batch-builder > footer button {
  min-height: 40px;
  border: 0;
  border-radius: 8px;
  padding: 0 16px;
  background: #167b58;
  color: #fff;
  font-size: 12px;
  font-weight: 750;
}

.batch-builder > footer button:disabled {
  opacity: 0.45;
}

.batch-history > header {
  min-height: 54px;
  padding: 0 17px;
  border-bottom: 1px solid #e7edea;
}

.batch-history h2 small {
  color: #819089;
  font-size: 12px;
  font-weight: 600;
}

.batch-row {
  display: grid;
  grid-template-columns: minmax(220px, 1.4fr) repeat(3, 0.35fr) 0.7fr;
  gap: 16px;
  align-items: center;
  padding: 14px 17px;
  border-bottom: 1px solid #edf1ef;
}

.batch-row:last-child {
  border-bottom: 0;
}

.batch-main, .batch-row > div {
  min-width: 0;
}

.batch-main > em {
  display: inline-block;
  padding: 3px 6px;
  border-radius: 5px;
  background: #e2f2eb;
  color: #217456;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
}

.batch-main > strong, .batch-main > small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.batch-main > strong {
  margin-top: 5px;
  font-size: 12px;
}

.batch-main > small, .batch-row > div:not(.batch-main) > span, .reviewer-names small {
  margin-top: 3px;
  color: #84918b;
  font-size: 10px;
}

.batch-row > div:not(.batch-main) > span {
  display: block;
}

.batch-row > div:not(.batch-main) > strong {
  display: block;
  margin-top: 4px;
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.state-card {
  padding: 36px;
  border: 1px dashed #cbd8d2;
  border-radius: 12px;
  background: #fff;
  color: #66756f;
  font-size: 12px;
  text-align: center;
}

.state-card strong {
  display: block;
  color: #283a33;
  font-size: 16px;
}

.state-card p {
  margin: 7px 0 0;
  font-size: 11px;
}

.state-card.compact {
  border: 0;
  border-radius: 0;
}

@media (max-width: 1050px) {
  .selection-grid {
    grid-template-columns: 1fr;
  }
  .batch-row {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .reviewer-names {
    display: none;
  }
}
@media (max-width: 760px) {
  .batches-page {
    margin: 14px;
    padding: 0 16px 18px;
  }
  .page-heading {
    align-items: flex-start;
    flex-direction: column;
    margin: 0 -16px 16px;
    padding: 14px 16px;
  }
  .page-actions {
    width: 100%;
  }
  .page-actions > * {
    flex: 1;
  }
  .builder-form {
    grid-template-columns: 1fr;
  }
  .batch-builder > footer {
    align-items: stretch;
    flex-direction: column;
  }
  .batch-row {
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .candidate-selector > header {
    grid-template-columns: 1fr;
  }
  .selection-actions {
    justify-content: flex-start;
  }
}`],
})
export class PageAuthoringReview_batchesComponent implements OnInit {
    public loading: boolean = true;
    public publishing: boolean = false;
    public runs: any[] = [];
    public candidates: any[] = [];
    public reviewers: any[] = [];
    public batches: any[] = [];
    public policy: any = {};
    public selectedCandidateIds: string[] = [];
    public selectedReviewerIds: string[] = [];
    public candidateSelection: { [id: string]: boolean } = {};
    public reviewerSelection: { [id: string]: boolean } = {};
    public filters: any = { run_id: '', q: '' };
    public form: any = this.newForm();

    constructor(@Inject( Service) public service: Service) { }

    public newForm() {
        return {
            batch_name: '전문가 검수 ' + formatKstDate(new Date(), ''),
            due_at: '',
            idempotency_key: 'review-' + Date.now().toString(36) + '-' + Math.random().toString(36).substring(2, 10)
        };
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public currentDataset() {
        return this.service.auth.session.current_dataset || {};
    }

    public canPublish() {
        let roles = this.currentDataset().roles || [];
        return this.service.auth.session.user_type === 'SYSTEM_ADMIN'
            || roles.indexOf('DATASET_ADMIN') >= 0
            || roles.indexOf('REVIEW_ADMIN') >= 0;
    }

    public canAdjudicate() {
        let roles = this.currentDataset().roles || [];
        return this.service.auth.session.user_type === 'SYSTEM_ADMIN'
            || roles.indexOf('REVIEW_ADMIN') >= 0
            || roles.indexOf('ADJUDICATOR') >= 0;
    }

    private async showError(message: string) {
        await this.service.modal.show({
            title: '처리 실패',
            message: message,
            cancel: false,
            action: '확인',
            actionBtn: 'error',
            status: 'error'
        });
    }

    public async load() {
        if (!this.currentDataset().dataset_id) {
            this.loading = false;
            return;
        }
        this.loading = true;
        await this.loadPrepare();
        await this.loadBatches();
        this.loading = false;
        await this.service.render();
    }

    public async loadPrepare(selectDefault: boolean = true) {
        let result: any = await this.service.request.post('/api/reviews/batches/prepare', {
            dataset_id: this.currentDataset().dataset_id,
            run_id: this.filters.run_id,
            q: this.filters.q
        });
        if (result.code !== 200) {
            await this.showError(result.data && result.data.message ? result.data.message : '발행 준비 정보를 불러오지 못했습니다.');
            return;
        }
        this.runs = result.data.runs || [];
        this.reviewers = result.data.reviewers || [];
        this.candidates = result.data.candidates || [];
        this.policy = result.data.policy || {};
        this.syncCandidateSelection();
        this.syncReviewerSelection();
        if (selectDefault && !this.filters.run_id && this.runs.length) {
            this.filters.run_id = this.runs[0].id;
            await this.loadPrepare(false);
        }
        await this.service.render();
    }

    public async loadBatches() {
        let result: any = await this.service.request.post('/api/reviews/batches/list', {
            dataset_id: this.currentDataset().dataset_id
        });
        if (result.code !== 200) {
            await this.showError(result.data && result.data.message ? result.data.message : 'Review Batch 이력을 불러오지 못했습니다.');
            return;
        }
        this.batches = result.data.batches || [];
        await this.service.render();
    }

    public isCandidateSelected(id: string) {
        return Boolean(this.candidateSelection[id]);
    }

    public async setCandidateSelected(id: string, selected: boolean) {
        if (selected && !this.candidateSelection[id]
            && this.selectedCandidateIds.length >= this.candidateLimit()) {
            await this.service.render();
            return;
        }
        this.candidateSelection[id] = selected;
        this.syncCandidateSelection();
        await this.service.render();
    }

    public async selectVisibleCandidates() {
        let available = this.candidateLimit() - this.selectedCandidateIds.length;
        for (let candidate of this.candidates) {
            if (available <= 0) break;
            if (!this.candidateSelection[candidate.id]) {
                this.candidateSelection[candidate.id] = true;
                available -= 1;
            }
        }
        this.syncCandidateSelection();
        await this.service.render();
    }

    public async clearCandidateSelection() {
        this.candidateSelection = {};
        this.selectedCandidateIds = [];
        await this.service.render();
    }

    public candidateLimit() {
        return Number(this.policy.candidate_max || 100);
    }

    private syncCandidateSelection() {
        this.selectedCandidateIds = Object.keys(this.candidateSelection)
            .filter((id: string) => this.candidateSelection[id])
            .slice(0, this.candidateLimit());
    }

    public isReviewerSelected(id: string) {
        return Boolean(this.reviewerSelection[id]);
    }

    public async setReviewerSelected(id: string, selected: boolean) {
        if (selected && !this.reviewerSelection[id]
            && this.selectedReviewerIds.length >= Number(this.policy.reviewer_max || 20)) {
            await this.service.render();
            return;
        }
        this.reviewerSelection[id] = selected;
        this.syncReviewerSelection();
        await this.service.render();
    }

    public async selectAllReviewers() {
        for (let reviewer of this.reviewers.slice(0, Number(this.policy.reviewer_max || 20))) {
            this.reviewerSelection[reviewer.id] = true;
        }
        this.syncReviewerSelection();
        await this.service.render();
    }

    public async clearReviewerSelection() {
        this.reviewerSelection = {};
        this.selectedReviewerIds = [];
        await this.service.render();
    }

    private syncReviewerSelection() {
        this.selectedReviewerIds = Object.keys(this.reviewerSelection)
            .filter((id: string) => this.reviewerSelection[id])
            .slice(0, Number(this.policy.reviewer_max || 20));
    }

    public async changeRun() {
        await this.clearCandidateSelection();
        await this.loadPrepare(false);
    }

    public async searchCandidates() {
        await this.loadPrepare(false);
    }

    public async publish() {
        if (this.publishing) return;
        if (!this.filters.run_id || !this.selectedCandidateIds.length) {
            await this.showError('같은 Generation Run의 발행 가능한 QA 후보를 선택해 주세요.');
            return;
        }
        if (this.selectedReviewerIds.length < Number(this.policy.reviewer_min || 2)) {
            await this.showError('독립 검수를 위해 서로 다른 검수자 2명 이상을 선택해 주세요.');
            return;
        }
        let selectedReviewers = this.reviewers.filter(
            (reviewer: any) => this.selectedReviewerIds.indexOf(reviewer.id) >= 0
        );
        if (this.policy.medical_reviewer_required
            && !selectedReviewers.some((reviewer: any) => reviewer.user_type === 'MEDICAL_REVIEWER')) {
            await this.showError('골든 QA 검수에는 자격이 확인된 외부 한의사 1명 이상이 필요합니다.');
            return;
        }
        if (!this.form.batch_name || this.form.batch_name.trim().length < 2) {
            await this.showError('Review Batch 이름을 2자 이상 입력해 주세요.');
            return;
        }
        let confirmed = await this.service.modal.show({
            title: 'Review Batch 발행',
            message: this.selectedCandidateIds.length + '개 후보를 Snapshot으로 동결하고 ' + this.selectedReviewerIds.length + '명의 검수자에게 배정합니다.',
            cancel: '취소',
            action: '발행',
            actionBtn: 'success',
            status: 'success'
        });
        if (!confirmed) return;

        this.publishing = true;
        await this.service.render();
        try {
            let result: any = await this.service.request.post('/api/reviews/batches/publish', {
                dataset_id: this.currentDataset().dataset_id,
                batch_name: this.form.batch_name,
                candidate_ids: this.selectedCandidateIds.join(','),
                reviewer_ids: this.selectedReviewerIds.join(','),
                due_at: this.form.due_at,
                idempotency_key: this.form.idempotency_key
            });
            if (result.code !== 200 && result.code !== 201) {
                await this.showError(result.data && result.data.message ? result.data.message : 'Review Batch를 발행하지 못했습니다.');
                return;
            }
            await this.service.modal.show({
                title: result.data.created ? '검수 배정 완료' : '동일 발행 요청 확인',
                message: result.data.batch.name + ' Batch가 ' + result.data.batch.reviewer_count + '명의 검수자에게 배정되었습니다.',
                cancel: false,
                action: '확인',
                actionBtn: 'success',
                status: 'success'
            });
            this.form = this.newForm();
            await this.clearCandidateSelection();
            await this.clearReviewerSelection();
            await this.load();
        } finally {
            this.publishing = false;
            await this.service.render();
        }
    }

    public statusLabel(value: string) {
        let labels: any = {
            DRAFT: '작성 중',
            PUBLISHED: '검수 진행',
            IN_PROGRESS: '일부 검수',
            REVIEWED: '독립검수 완료',
            ADJUDICATING: '이견조정',
            CLOSED: '검수 종료',
            CANCELED: '취소'
        };
        return labels[value] || value;
    }

    public reviewerTypeLabel(value: string) {
        return value === 'MEDICAL_REVIEWER' ? '외부 한의사' : '내부 연구원';
    }

    public formatDate(value: string) {
        return formatKstDateTime(value, '기한 없음');
    }

    public shortHash(value: string) {
        return value ? value.substring(0, 12) : '-';
    }
}

export default PageAuthoringReview_batchesComponent;